import React, { useState } from 'react';
import { Layout, Menu, Icon } from 'antd';
import { Link } from 'react-router-dom'
import 'antd/dist/antd.css'
import '../static/style/components/antd-expand.css'

function AdminMenu(){
    //const { SubMenu } = Menu;
    const { Sider } = Layout;
    //设置左侧导航缩放
    const [collapsed, setCollapse] = useState(false);
    const onCollapse = collapsed => {
        setCollapse(collapsed)
    }

    //商店图标
    //const StoreIcon = () => (<svg t="1581256593329" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2599" width="16" height="16"><path d="M810.666667 576c-64 0-119.466667-36.266667-149.333333-89.6-29.866667 53.333333-85.333333 89.6-149.333333 89.6s-119.466667-36.266667-149.333333-89.6c-29.866667 53.333333-85.333333 89.6-149.333333 89.6-93.866667 0-170.666667-76.8-170.666667-170.666667l0 0c0-4.266667 0-6.4 2.133333-10.666667l128-277.333333c0-2.133333 2.133333-2.133333 4.266667-4.266667 0 0 0-2.133333 2.133333-2.133333 2.133333-2.133333 4.266667-2.133333 6.4-4.266667 0 0 0 0 0 0C187.733333 106.666667 189.866667 106.666667 194.133333 106.666667l635.733333 0c4.266667 0 6.4 0 10.666667 2.133333 0 0 0 0 0 0 2.133333 0 4.266667 2.133333 6.4 4.266667 0 0 0 2.133333 2.133333 2.133333 2.133333 2.133333 2.133333 2.133333 4.266667 4.266667l128 277.333333C981.333333 398.933333 981.333333 401.066667 981.333333 405.333333l0 0C981.333333 499.2 904.533333 576 810.666667 576zM817.066667 149.333333 206.933333 149.333333 85.333333 409.6c2.133333 68.266667 57.6 123.733333 128 123.733333 55.466667 0 102.4-36.266667 119.466667-85.333333l12.8 0 32 0 12.8 0c17.066667 49.066667 64 85.333333 119.466667 85.333333s102.4-36.266667 119.466667-85.333333l12.8 0 32 0 12.8 0c17.066667 49.066667 64 85.333333 119.466667 85.333333 68.266667 0 125.866667-55.466667 128-123.733333L817.066667 149.333333zM768 362.666667 277.333333 362.666667c-12.8 0-21.333333-8.533333-21.333333-21.333333s8.533333-21.333333 21.333333-21.333333l490.666667 0c12.8 0 21.333333 8.533333 21.333333 21.333333S780.8 362.666667 768 362.666667zM149.333333 618.666667c12.8 0 21.333333 8.533333 21.333333 21.333333l0 192c0 23.466667 19.2 42.666667 42.666667 42.666667l597.333333 0c23.466667 0 42.666667-19.2 42.666667-42.666667l0-192c0-12.8 8.533333-21.333333 21.333333-21.333333s21.333333 8.533333 21.333333 21.333333l0 192c0 46.933333-38.4 85.333333-85.333333 85.333333L213.333333 917.333333c-46.933333 0-85.333333-38.4-85.333333-85.333333l0-192C128 627.2 136.533333 618.666667 149.333333 618.666667z" p-id="2600" fill="#cdcdcd"></path></svg>);

    return (
        <Sider collapsible collapsed={collapsed} onCollapse={onCollapse}>
            <div className="logo" />
            <Menu theme="dark" defaultSelectedKeys={['1']} mode="inline">
                <Menu.Item key="1">
                    <Link to="/home/">
                        <Icon type="home" />
                        <span>首页</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="2">
                    <Link to="/company/">
                        <Icon type="solution" />
                        <span>公司管理</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="3">
                    <Link to="/store/">
                        <Icon type="inbox" />
                        <span>商店管理</span>
                    </Link>
                    
                </Menu.Item>
            </Menu>
        </Sider>
    );
}

export default AdminMenu;